export const DeliveryMethodLabel = {
  ['b2cloud_cash_on_delivery']: 'B2クラウド_着払い',
  ['b2cloud_collect']: 'B2クラウド_コレクト',
  ['b2cloud_compact']: 'B2クラウド_宅急便コンパクト',
  ['b2cloud_compact_collect']: 'B2クラウド_宅急便コンパクトコレクト',
  ['b2cloud_dm']: 'B2クラウド_ＤＭ便',
  ['b2cloud_nekopos']: 'B2クラウド_ネコポス',
  ['b2cloud_prepayment']: 'B2クラウド_発払い',
  ['b2cloud_time']: 'B2クラウド_タイム',
  ['parcel']: '宅配便',
  ['hand']: '薬局にてお渡し',
  ['same_day_delivery']: '当日受取配達',
  ['other']: 'その他',
};
